import { render, staticRenderFns } from "./overPaymentAllocationDialog.vue?vue&type=template&id=48866efa&scoped=true&"
import script from "./overPaymentAllocationDialog.vue?vue&type=script&lang=js&"
export * from "./overPaymentAllocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./overPaymentAllocationDialog.vue?vue&type=style&index=0&id=48866efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48866efa",
  null
  
)

export default component.exports